module.exports = __webpack_public_path__ + "img/seguros.c05dfa65.jpg";